import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPhone, FiMail, FiAward } = FiIcons;
const CQC_LOCATION_URL = 'https://www.cqc.org.uk/location/1-7077360945';
const CQC_WIDGET_URL = 'https://www.cqc.org.uk/sites/all/modules/custom/cqc_widget/widget.js?data-id=1-7077360945&data-host=https://www.cqc.org.uk&type=location';

const Footer = () => {
  const cqcWidgetRef = useRef(null);

  useEffect(() => {
    const mount = cqcWidgetRef.current;
    if (!mount) return;

    const timer = window.setTimeout(() => {
      const script = document.createElement('script');
      script.src = CQC_WIDGET_URL;
      script.async = true;
      mount.appendChild(script);
    }, 0);

    return () => {
      window.clearTimeout(timer);
      mount.replaceChildren();
    };
  }, []);

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Link to="/" className="inline-block rounded-xl bg-white p-2" aria-label="KCG home">
              <img
                src="/brand/kcg-logo.svg"
                alt="KCG — Kabod Care Group"
                className="w-44 h-auto"
                width="962"
                height="405"
              />
            </Link>
            <p className="text-gray-300 text-sm leading-relaxed">
              Bringing warmth, compassion, and professional care to families across our community. Your home is where your heart is, and we're here to help you stay.
            </p>
            
            <div className="py-4">
              <div className="flex items-center space-x-2 mb-3">
                <SafeIcon icon={FiAward} className="w-5 h-5 text-primary-400" />
                <span className="text-sm font-medium text-gray-300">North Tyneside CQC rating</span>
              </div>
              <div className="rounded-lg bg-white p-3 text-gray-900">
                <div ref={cqcWidgetRef} id="cqc-widget-container" />
                <a
                  href={CQC_LOCATION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2 inline-block text-sm font-medium text-primary-900 underline underline-offset-2"
                >
                  View North Tyneside’s rating on CQC
                </a>
              </div>
              <p className="mt-2 text-xs text-gray-400">
                CQC currently lists this service under our former company name, Odara Care Limited.
              </p>
            </div>

          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-primary-400 transition-colors">About Our Family</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-primary-400 transition-colors">Care Services</Link></li>
              <li><Link to="/careers" className="text-gray-300 hover:text-primary-400 transition-colors">Careers & Jobs</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-primary-400 transition-colors">Care Stories</Link></li>
              <li><Link to="/where-we-operate" className="text-gray-300 hover:text-primary-400 transition-colors">Where We Operate</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-primary-400 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Care We Provide</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">Personal Care at Home</li>
              <li className="text-gray-300">Daily Companionship</li>
              <li className="text-gray-300">Memory Care Support</li>
              <li className="text-gray-300">Family Respite Care</li>
              <li className="text-gray-300">Live-in Care</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Get In Touch</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-primary-400 mt-0.5" />
                <div>
                  <p className="text-gray-300">Call us</p>
                  <a href="tel:03333394077" className="text-white font-medium hover:underline">03333 394 077</a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-primary-400 mt-0.5" />
                <div>
                  <p className="text-gray-300">Email Us</p>
                  <a href="mailto:enquiries@odaracare.org.uk" className="text-white font-medium hover:underline break-all">enquiries@odaracare.org.uk</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2026 Kabod Care Group Ltd. Trading as KCG.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
